module.exports = __webpack_public_path__ + "img/team.96679b18.svg";